// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-address__add-address{display:flex;align-items:center}.edit-address__add-address a{flex:0 1 auto}#edit-address-modal .edit-address .content-container{max-height:calc(90vh - 275px)}", ""]);
// Exports
module.exports = exports;
